import React from 'react';

export const USE_NONCE_START_VALUE = 1;

/**
 * Returns a number and a function to increase it.
 * Number starts at 1 and increases with 1 each time the refresh callback is called.
 */
export const useNonce = () => {
  const [value, setValue] = React.useState(USE_NONCE_START_VALUE);

  const refresh = React.useCallback(() => {
    setValue((x) => x + 1);
  }, []);

  return [value, refresh] as const;
};
